import { render, staticRenderFns } from "./invitedUserSuccess.vue?vue&type=template&id=00b6869e&scoped=true&"
import script from "./invitedUserSuccess.vue?vue&type=script&lang=js&"
export * from "./invitedUserSuccess.vue?vue&type=script&lang=js&"
import style0 from "./invitedUserSuccess.vue?vue&type=style&index=0&id=00b6869e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6869e",
  null
  
)

export default component.exports